import React, { useState } from "react";
import { Dropdown } from "antd";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";
import { COUNTRY_CONFIGS } from "../../Config/countryConfig";

const DialCodeSelector = ({ value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);

  const currentCountry =
    COUNTRY_CONFIGS.find((c) => c.dialCode === value) || COUNTRY_CONFIGS[0];

  const handleMenuClick = ({ key }) => {
    if (onChange) {
      onChange(key);
    }
  };

  const menuItems = COUNTRY_CONFIGS.map((country) => ({
    key: country.dialCode,
    label: (
      <div className="flex items-center gap-x-2 py-1 px-1.5 font-aileron text-xs text-black">
        <span className="text-base select-none leading-none">{country.flag}</span>
        <span className="font-semibold">{country.dialCode}</span>
        <span className="text-dark-gray">({country.name})</span>
      </div>
    ),
  }));

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleMenuClick,
      }}
      disabled={disabled}
      trigger={["click"]}
      placement="bottomLeft"
      onOpenChange={(nextOpen) => setOpen(nextOpen)}
    >
      <div
        className={`flex items-center gap-x-1 cursor-pointer select-none py-1.5 px-2 rounded-l border-r border-[#E8E8E8] bg-white transition-colors h-full ${
          disabled ? "opacity-30 cursor-not-allowed" : "hover:bg-background-grey-hover"
        }`}
      >
        <span className="text-base leading-none select-none mt-[-1px]">{currentCountry.flag}</span>
        <span className="font-aileron text-xs font-semibold leading-none text-black mt-[1px]">
          {currentCountry.dialCode}
        </span>
        <ChevronIcon
          strokeWidth="1"
          className={`w-3.5 h-3.5 stroke-black transform transition-transform duration-[300ms] mt-[1.5px] ${
            open ? "-rotate-90" : "rotate-90"
          }`}
        />
      </div>
    </Dropdown>
  );
};

export default DialCodeSelector;
